import { stringify } from "qs";
import { fetch, getHeaders, makeRequest } from "$utils/utils";
import config from "./config";

const { sync_url, api_url: url } = config;

export enum ERRORS {
  MISSING_FIELD = "Donnée manquante !",
  ADD_ERROR = "Une erreur s'est produite lors de l'ajout de l'entrepot",
  DOCK_EXISTS = "Cet entrepot existe déjà !",
  NOT_FOUND = "Entrepot introuvable",
  UPDATE_ERROR = "Une erreur s'est produite lors de la mise à jour de l'entrepot",
}

export const AddEntrepot = async (token: string, data: any) => {
  try {
    const res = await makeRequest(
      `${url}/api/entrepot`,
      "POST",
      data,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(ERRORS.ADD_ERROR);
    }
    return res.data.data;
  } catch (err) {
    let error = (err as any)?.response?.data?.message;
    if (error && error.includes("already exists")) {
      error = ERRORS.DOCK_EXISTS;
    } else {
      error = ERRORS.ADD_ERROR;
    }
    return { error };
  }
};

export const getEntrepotById = async (id: string) => {
  try {
    const { data } = await fetch(`/api/entrepot/${id}`);
    return data.data;
  } catch (err) {
    throw new Error(err?.message);
  }
};

export const getEntrepots = async (params) => {
  try {
    const { data } = await fetch(
      `/api/entrepot/withoutCache?${stringify(params, {
        arrayFormat: "brackets",
      })}`
    );
    return data;
  } catch (err) {
    throw new Error(err?.message);
  }
};

// export const GetEntrepots = async (token: string, query = "") => {
//   try {
//     const res = await makeRequest(
//       `${url}/api/entrepot?${query}`,
//       "GET",
//       undefined,
//       getHeaders(token)
//     );
//     if (!res || !res.data || !res.data.status) {
//       throw new Error(ERRORS.ADD_ERROR);
//     }
//     return res.data.data;
//   } catch (err) {
//     return [];
//   }
// };

export const getEntrepot = async (token: string, id: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/entrepot/${id}`,
      "GET",
      undefined,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(ERRORS.NOT_FOUND);
    }
    return res.data.data;
  } catch {
    return undefined;
  }
};

export const getEntrepotsByName = async (token: string, name: string) => {
  try {
    const res = await makeRequest(
      `${url}/api/entrepot/search/byName?input=${name}`,
      "GET",
      undefined,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(ERRORS.NOT_FOUND);
    }
    return res.data.data;
  } catch {
    return undefined;
  }
};

export const updateEntrepot = async (token: string, id: string, body: any) => {
  try {
    const res = await makeRequest(
      `${url}/api/entrepot/${id}`,
      "PUT",
      body,
      getHeaders(token)
    );
    if (!res || !res.data || !res.data.status) {
      throw new Error(ERRORS.NOT_FOUND);
    }
    return res.data.data;
  } catch (err) {
    let error = (err as any)?.response?.data?.message;
    if (error && error.includes("already exists")) {
      error = ERRORS.DOCK_EXISTS;
    } else {
      error = ERRORS.UPDATE_ERROR;
    }
    return { error };
  }
};

export const syncEntrepot = async (
  warehouseId: string,
  companyId: string,
  token: string
) => {
  const response = await makeRequest(
    `${sync_url}/api/entrepot/sync?warehouse=${warehouseId}&company=${companyId}`,
    "POST",
    undefined,
    getHeaders(token)
  );

  return response;
};

export const syncProducts = async (token: string, body: any) => {
  const response = await makeRequest(
    `${url}/api/product/sync`,
    "POST",
    body,
    getHeaders(token)
  );

  return response;
};

export const getWMSWarehouses = async (token: string) => {
  try {
    const response = await makeRequest(
      `${url}/api/wms/warehouses?token=${token}`,
      "GET",
      undefined,
      getHeaders()
    );

    return response.data;
  } catch (err) {
    return { error: (err as any)?.message ?? null };
  }
};
